import { render, staticRenderFns } from "./SenaEditionTickets.vue?vue&type=template&id=4c4e3ee8&"
import script from "./SenaEditionTickets.vue?vue&type=script&lang=js&"
export * from "./SenaEditionTickets.vue?vue&type=script&lang=js&"
import style0 from "./SenaEditionTickets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports